import { z } from "zod";
import { scheduleApplicationStatusSchema } from "./schedule.schema";

/**
 * A schedule living on the other side of a confirmed match, shown read-only
 * in the Schedule column of the unscheduled side.
 */
export const matchedScheduleSchema = z.object({
    scheduleApplicationId: z.string().uuid(),
    scheduleName: z.string(),
    status: scheduleApplicationStatusSchema,
    termEnd: z.string().date().nullable(),
    remainingAmount: z.number(),
    /** The invoice or transaction the schedule lives on. */
    sourceId: z.string(),
    /** The invoice number; null for a transaction or an unnumbered invoice. */
    sourceReference: z.string().nullable(),
});

export type MatchedSchedule = z.infer<typeof matchedScheduleSchema>;
